// شناسه‌ی ماندگارِ این گوشی (بدونِ نیاز به حساب) — برای لینک‌های اشتراک و تبِ «شیر» — و مشخصاتِ آدمکِ کاربر در
// بازدیدِ مشترک (اسم و مرد/زن) که یک بار انتخاب می‌شود و می‌ماند
const DEVICE_KEY = 'kh-device-v1';
const PROFILE_KEY = 'kh-live-profile-v1';

let cached = null;
export function getDeviceId() {
  if (cached) return cached;
  try {
    cached = localStorage.getItem(DEVICE_KEY);
  } catch (e) {
    cached = null;
  }
  if (!cached || !/^[A-Za-z0-9_-]{16,64}$/.test(cached)) {
    const bytes = new Uint8Array(18);
    (window.crypto || {}).getRandomValues ? window.crypto.getRandomValues(bytes) : bytes.forEach((_, i) => (bytes[i] = Math.random() * 256));
    cached = btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    try {
      localStorage.setItem(DEVICE_KEY, cached);
    } catch (e) {
      /* حالتِ خصوصی: فقط برای همین نوبت */
    }
  }
  return cached;
}

// { name, char } یا null — char: شناسه‌ی آدمکِ واقعی (مثلاً ch13) یا 'm' / 'f' (آدمکِ ساده)
export function getLiveProfile() {
  try {
    const p = JSON.parse(localStorage.getItem(PROFILE_KEY) || 'null');
    if (p && typeof p.name === 'string' && typeof p.char === 'string' && /^[a-z0-9_-]{1,16}$/.test(p.char)) return p;
  } catch (e) {
    /* */
  }
  return null;
}

export function setLiveProfile(p) {
  try {
    localStorage.setItem(PROFILE_KEY, JSON.stringify({ name: String(p.name || '').slice(0, 24), char: /^[a-z0-9_-]{1,16}$/.test(String(p.char || '')) ? p.char : 'm' }));
  } catch (e) {
    /* */
  }
}
